// Who sees the charts above the Ratings table (CP-5220). Every operator's staff since 2026-10-29, when
// the help@ preview ended; an operator's config.features.review_insights set to false turns them off
// for it. The backend summary endpoint is not gated: it only totals reviews the caller may already list.
export function canSeeReviewInsights(tourOperator) {
    return tourOperator?.config?.features?.review_insights !== false;
}
